'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = g11nFormat;

var _i18n = require('../../i18n.json');

var _i18n2 = _interopRequireDefault(_i18n);

var _hudlG11n = require('hudl-g11n');

var _hudlG11n2 = _interopRequireDefault(_hudlG11n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function g11nFormat(key) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return _hudlG11n2.default.format(key, args, _i18n2.default['base-language'][key]);
}
module.exports = exports['default'];